import React, { useRef, useState,useCallback } from 'react';
import { APIEndpoint,DFPAPIEndpoint } from "../../../utils/axios";
import { DataGrid,MappingModal , UploadModal } from "../../../common";
import { MIMETypes } from '../../../utils/configs';
import { onDownloadXlsFile } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';
import editIcon2 from "../../../assets/edit2.svg";
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import uploadItemIcon from '../../../assets/icons/upload-items.svg';
import LoadingGIF from "../../../assets/loadingIn.gif"
import usePermissions from '../../../utils/userPermissions';
const Columns = [
  { field: 'itemCode', headerName: 'Item Code',  flex:1,suppressSizeToFit:true,resizable:true,minWidth:150,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  } },
  { field: 'itemName', headerName: 'Name' ,flex:1,suppressSizeToFit:true,resizable:true,minWidth:250,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  } },
  { field: 'category', headerName: 'Category',  flex:1,suppressSizeToFit:true,resizable:true,minWidth:120,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  } },
  { field: 'subCategory', headerName: 'Sub Category',  flex:1, suppressSizeToFit:true,minWidth:120,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  } },
];


export const ManageCombosPage = (props) => {
  const priceListOptions = useRef(null);
  const [isDownloading, setIsDownloading] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showMapping, setShowMapping] = useState(false);
  const [mappingData, setMappingData] = useState({});
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [actionItems, setActionItems] = useState([]);
  const [itemList,setItemList] =useState([]);
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const { hasPermission: createCombos } = usePermissions('create', "inventory.combos");
  const { hasPermission: editCombos } = usePermissions('edit', "inventory.combos");
  const { hasPermission: viewCombos } = usePermissions('viewDetails', "inventory.combos");
  const { hasPermission: uploadCombos } = usePermissions('upload', "inventory.combos");
  const { hasPermission: downloadCombos } = usePermissions('download', "inventory.combos");

  const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);

  const Fields = useRef([]);
  const { t,ready } = useTranslation();
  const [state, setState] = useState({ isListReady: false, filterPrice: '', resetDataSource: false, })
  React.useEffect(() => {
    setActionItems([{ title: '',maxWidth:200,minWidth:170, detail:[{src: editIcon2,value:"edit",title:'Edit Mappings'}]}])
    fetchPriceList();
    fetchEnumerate();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

React.useEffect(() => {
  if (!modalFormStatusObj?.text && !modalFormStatusObj?.error) return;

  const timer = setTimeout(() => {
    setModalFormStatusObj({ text: '' });
  }, 2500);

  return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps

}, [modalFormStatusObj]);

   const fetchEnumerate = useCallback(async () => {
    try {
      if (itemList.length) return;
  
      const { items = [] } = await APIEndpoint.get('items/enumerate') || {};
  
      if (!items.length) return;
  
      setItemList(items);
  
    } catch (error) {
      console.error("Failed to fetch item list:", error); 
    }
  }, [itemList]); 

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };
  const fetchCombos = async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
    filterData.page = iPageNo;
    filterData.limit = iPageLimit;
    filterData.searchParam = iSearchText;
    if (state.filterPrice) {
      filterData.filters = [{ listName: state.filterPrice }]
    }
    const res = await APIEndpoint.post('combos/items', filterData);
    return res;
  }

  const fetchServings = async (itemId) => {
    try {
      const servingList = await APIEndpoint.get('recipe/'+itemId+'/servings');
      if (servingList.result) {
        return servingList.result;
      }else{
        return null;
      }
    } catch (error) {
      
    }
  };

  const fetchPriceList = async () => {
    setState((_) => {
      return { ..._, isListReady: true }
    })
    try {
      const priceList = await APIEndpoint.get('items/price-list');
    if (priceList.result.length) {
      priceListOptions.current = priceList.result.map((_pl) => {
        return { value: _pl, label: _pl }
      })
    }
    } catch (error) {

    }

    Fields.current = getFormFields()
  };

  const getFormFields = () => {
    return 0
  }

  const handleRowAction = async (e, action, row) => {
    let editRow = null, detailsRow = null;
    try {   
      if (action.value === 'edit' && Array.isArray(itemList)) {
        const servingData = await fetchServings(row.itemId);
        if(servingData && servingData?.items?.length === 0){
          setModalFormStatusObj({ error: t('pages.productsContent.manageCombos.noMappings') });
        }
        setMappingData({
          title: row,
          itemList,
          map_data: servingData,
        })
        setShowMapping(true)
      } else {
        detailsRow = JSON.parse(JSON.stringify(row))
      }
    } catch (error) {
      
    }
    setState((currentState) => {
      return { ...currentState, editRow: editRow, detailsRow: detailsRow }
    })
  }

  const handleMappingSubmit = async (e, values) => {
    const itemId = e.target.value;
    setModalFormStatusObj({ text: '' });
    try{
      if (values != null) {
        const res = await APIEndpoint.put('recipe/'+itemId+'/servings', {servings: values});

        if (res.success) {
          setModalFormStatusObj({ text: res?.msg ||"Servings added successfully" });
        }
      }
    } catch (error) {
      const err=JSON.parse(error.message);
      setModalFormStatusObj({ error: err.data?.message ||"Something went wrong. Please try again after some time." });
    }

  }

  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName', undefined);
    formData.append('targetSectorType', undefined);
    formData.append('stores', []);
    formData.append('warehouses', []);
    formData.append('file', file);

    try {
      await DOMAIN.post('combos/upload', formData);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setState( (_prev) => {
        return { ..._prev,resetDataSource:true}
      });
      setUploadedFile([]);
    }
    catch(error) {
      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400) {
            data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
      } else if(status===0 && !data){
        msgContent += `Error occurred while uploading commbos sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading combos sheet!<br>Please fix the errors and re-upload.`;
      }

      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};

  const onDownloadCombo=async()=>{
    let header={
      'Accept':'text/csv'
    }
    try {
      setIsDownloading(true)
    const res= await APIEndpoint.post(`sales/reports`,{reportType: "comboItemMaster"},header);
    if(res.status==='scheduled'){
      setTimeout(() => {
        setIsDownloading(true)
        const dowId = APIEndpoint.get(`downloads/status/${res.id}`);
        dowId.then((val)=> {
          if(val.status==="completed"){
            const ItemMasterDwnld = APIEndpoint.get(`downloads/analytics/${val.fileName}${val.fileExtension}`);
            ItemMasterDwnld.then((res) => {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', val.fileName+'.csv'); //or any other extension
            document.body.appendChild(link);
            link.click();
            setIsDownloading(false)
            })
          }
        })
        }, 5000);
    }
    }
      catch (res) {
        setIsDownloading(false)
      }
  }

  const onUploadTaxMaster=()=>{
    setShowUpload(true)
  }
  const onUploadClose = () => {
    setUploadedFile([]);
    setUploadFileStatusBlock('');
    setShowUpload(false);
  }
  const handleModalClose = () => {
    setModalFormStatusObj({ text: '' });
    setShowMapping(false);
  }

  const onDownloadSampleFile = () => {
    onDownloadXlsFile('samples/downloads/Servings_Upload_Sample','Servings_Upload_Sample')
  }

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        Boolean(state.isListReady) &&
        <>

          <DataGrid
            columnResize
            resetDataSource={state.resetDataSource}
            showDefaultFilters
            className='full-flex'
            columns={Columns}
            getRows={fetchCombos}
            onAction={handleRowAction}
            pageType={false}
            actionProperties={{pinned:'right'}}
            actions={actionItems}
                           RightComponent={() => {
                  return ( uploadCombos || downloadCombos) ? (
                      <div className='flexRow width100 justifyContentFlexEnd'>
          <div className="margLeft flexRow justifyContentFlexEnd alignItemsBaseline">
          {uploadCombos?<button title={t('pages.productsContent.manageCombos.uploadMappings')} className='dropdownStyle1-TextMedium'  onClick={() => onUploadTaxMaster(true)}> <span><img  className="icon-size-min" alt='uploadItem' src={uploadItemIcon} /></span></button>:<></>}&nbsp;
              {downloadCombos? <div className="flexRow justifyContentFlexStart margRight">

                      {isDownloading ? (
                               <button className="margRight">
                                    <img
                                      src={LoadingGIF}
                                      className="margBottom0 icon-size-min"
                                      alt="Loading"
                                      title={t('filters.downloadingMaster')}
                                    />
                                  </button>
                              ) : (

                                  <button
                                    disabled={isDownloading}
                                    className="margRight"
                                    style={{ cursor: 'pointer' }}
                                    title={ t('filters.downloadMaster')}
                                   onClick={onDownloadCombo}
                                  >
                                    <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                                  </button>
                                )
                              }

          </div>:<></>}

          </div>
        </div>
                  ) : null;
                }}
          />
          {
            showMapping && createCombos && editCombos && viewCombos &&
            <MappingModal
              data={mappingData}
              onClose={handleModalClose}
              onSubmit={handleMappingSubmit}
              modalFormStatusObj={modalFormStatusObj}
              setModalFormStatusObj={setModalFormStatusObj}

            />
          }
          {
            showUpload &&
            <UploadModal
              modelTitle={t('pages.productsContent.manageCombos.uploadMappings')}
              onUploadClose={onUploadClose}
              onDownloadSampleFile={onDownloadSampleFile}
              uploadedFile = { uploadedFile }
              onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
              uploadFileStatusBlock = { uploadFileStatusBlock }
              allowedExtensions={ MIMETypes.excel }
            />
          }
        </>
      }
      {
                  !ready &&<div className='overlay_hide sub'></div>
                }
    </div>
  )
}

